type TeamNameSet = {
  readonly name: string;
  readonly members: readonly string[];
};

const TEAM_NAME_SETS: readonly TeamNameSet[] = [
  {
    name: "Composers",
    members: [
      "Mozart",
      "Beethoven",
      "Bach",
      "Chopin",
      "Vivaldi",
      "Tchaikovsky",
      "Debussy",
      "Handel",
      "Haydn",
      "Schubert",
      "Brahms",
      "Ravel",
    ],
  },
  {
    name: "Heroes",
    members: [
      "Athena",
      "Hercules",
      "Mulan",
      "Arthur",
      "Joan",
      "Odysseus",
      "Beowulf",
      "Atalanta",
      "Robin",
      "Perseus",
      "Diana",
      "Merlin",
    ],
  },
  {
    name: "Warriors",
    members: [
      "Samurai",
      "Knight",
      "Spartan",
      "Valkyrie",
      "Archer",
      "Gladiator",
      "Sentinel",
      "Ranger",
      "Ronin",
      "Paladin",
      "Raider",
      "Guardian",
    ],
  },
  {
    name: "Villains",
    members: [
      "Moriarty",
      "Medusa",
      "Loki",
      "Jafar",
      "Ursula",
      "Hades",
      "Maleficent",
      "Scar",
      "Voldemort",
      "Sauron",
      "Hook",
      "Cruella",
    ],
  },
  {
    name: "Leaders",
    members: [
      "Mandela",
      "Lincoln",
      "Cleopatra",
      "Churchill",
      "Gandhi",
      "Boudica",
      "Washington",
      "Victoria",
      "Eleanor",
      "Caesar",
      "Ashoka",
      "Elizabeth",
    ],
  },
  {
    name: "Philosophers",
    members: [
      "Socrates",
      "Plato",
      "Aristotle",
      "Hypatia",
      "Confucius",
      "Laozi",
      "Kant",
      "Locke",
      "Hume",
      "Nietzsche",
      "Arendt",
      "Simone",
    ],
  },
  {
    name: "Explorers",
    members: [
      "Amelia",
      "Marco",
      "Magellan",
      "Sacagawea",
      "Cook",
      "Nellie",
      "Darwin",
      "Shackleton",
      "Henson",
      "Earhart",
      "Zheng",
      "Leif",
    ],
  },
  {
    name: "Inventors",
    members: [
      "Tesla",
      "Edison",
      "Lovelace",
      "Turing",
      "Curie",
      "Franklin",
      "Bell",
      "Wright",
      "Hopper",
      "Latimer",
      "Farnsworth",
      "Goodenough",
    ],
  },
  {
    name: "Artists",
    members: [
      "Frida",
      "Picasso",
      "Monet",
      "Kahlo",
      "Dali",
      "O'Keeffe",
      "Rembrandt",
      "Matisse",
      "Basquiat",
      "Hokusai",
      "Warhol",
      "Klimt",
    ],
  },
  {
    name: "Scientists",
    members: [
      "Einstein",
      "Newton",
      "Galileo",
      "Darwin",
      "Feynman",
      "Hawking",
      "Meitner",
      "Faraday",
      "Sagan",
      "Noether",
      "Pasteur",
      "Goodall",
    ],
  },
];

export function getTeamNameSet(teamIndex: number) {
  return TEAM_NAME_SETS[teamIndex % TEAM_NAME_SETS.length]!;
}
